import React, { Component } from 'react';
import { Container, Row, Col} from 'react-bootstrap';
import DynamicSearchForm from '../components/DynamicSearchForm';
import SearchResults from '../components/SearchResults';
import ServiceCalls from '../utils/serviceCalls.js';
import '../styles/Search.css';
import { Loading } from '../components/Loading';
import RoleUtils from '../utils/roleUtils';
export class Search extends Component {

    constructor(props) {
        super(props);  
        this.onSearchSubmitted = this.onSearchSubmitted.bind(this);
        this.onSearchComplete = this.onSearchComplete.bind(this);
        this.state = {
            searchData: {},
            isSearchDisabled: false,
            isNoSearch: false,
            hasAccess: false,
            isLoading:true
        };
    }


    componentDidMount() {
        const { currentUser, currentCompanyId } = this.props;
        ServiceCalls.checkSupplierAccess(currentCompanyId).then(function (data) {
            if (data) {
                var hasCorrectRole = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.inquiryPerms());
                this.setState({
                    hasAccess: (data === false) ? false : (hasCorrectRole),
                    isLoading: false
                });
            }
            else {
                this.setState({ hasAccess: false, isLoading: false });
            }
        }.bind(this)); 
    }
    //Get additional users again when companyId changes
    componentDidUpdate(prevProps, prevState) {
        const { currentUser, currentCompanyId } = this.props;
        if (prevProps.currentCompanyId !== currentCompanyId) {
            console.log(`Refresh Search - Company changed from ${prevProps.currentCompanyId} to ${currentCompanyId}`);
            ServiceCalls.checkSupplierAccess(currentCompanyId).then(function (data) {
                if (data) {
                    var hasCorrectRole = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.inquiryPerms());
                    this.setState({
                        hasAccess: (data === false) ? false : (hasCorrectRole),
                        isLoading: false
                    });
                }
                else {
                    this.setState({ hasAccess: false, isLoading: false });
                }
            }.bind(this)); 
        }
    }
    onSearchSubmitted(searchData) {
        if (searchData) {
            //Check for no search  
            var noSearch = false;
            if (searchData["noSearch"]) {
                noSearch = true;
            }

            this.setState(
                {
                    searchData: searchData,
                    isSearchDisabled: (noSearch!==true),
                    isNoSearch: noSearch
                }
            );
        } else {
            this.setState(
                {
                    searchData: searchData,
                    isSearchDisabled: false,
                    isNoSearch: false
                }
            );
        }
    }
    onSearchComplete() {
        this.setState(
            {
                isSearchDisabled: false,
                isNoSearch: false
            }
        );
    }
    
    render() {
        const { currentCompanyId, currentUser } = this.props;
        const { searchData, isSearchDisabled, isNoSearch, hasAccess,isLoading } = this.state;
        const SearchResultsComp = (isNoSearch)
            ? <h4>Must specify at least one criteria to execute a search.</h4>
            : (searchData.curSupplierId > 0)
                ? (hasAccess === true)
                    ? <SearchResults searchData={searchData} curSupplierId={currentCompanyId} currentUser={currentUser} onSearchComplete={this.onSearchComplete} />
                    : <></>
                : <></>;
        const SearchForm = (hasAccess === true)
            ? <DynamicSearchForm curSupplierId={currentCompanyId} currentUser={currentUser} onSearchSubmitted = { this.onSearchSubmitted } isSearchDisabled = { isSearchDisabled } />
            
            : (isLoading)
                ? <div style={{ margin: "auto", width: "100px" }}>
                    <Loading />
                </div>
                : <h3 style={{ marginTop: "10px" }}>You do not have access rights to this page.</h3>;

        return (<Container id="searchPage" fluid>
            <Row>
                <Col><h3 className="primaryText">Invoices/Payments</h3></Col>
            </Row>
            {SearchForm}
            {SearchResultsComp}
        </Container>);
    }
}
